module.exports = __webpack_public_path__ + "img/Marcus Paramore.5efffd27.jpg";